module.exports = __webpack_public_path__ + "media/social/social-2-13145914.jpg";